export default function debounce<Args extends unknown[]>(delay: number, fn: (...args: Args) => void) {
  let timer: ReturnType<typeof setTimeout>

  return (...args: Args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}
